import { render, staticRenderFns } from "./newComManagementContent.vue?vue&type=template&id=06a51c82&scoped=true"
import script from "./newComManagementContent.vue?vue&type=script&lang=js"
export * from "./newComManagementContent.vue?vue&type=script&lang=js"
import style0 from "./newComManagementContent.vue?vue&type=style&index=0&id=06a51c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a51c82",
  null
  
)

export default component.exports